import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormGroup, FormBuilder, FormControl } from "@angular/forms"
import {
  GlcodeService,
  ApiVisa
} from "blg-akaun-ts-lib";

import { AppConfig } from "../../visa";
import { SubSink } from "subsink2";

@Component({
  selector: "app-select-gl-code-v2",
  templateUrl: "./select-gl-code-v2.component.html",
  styleUrls: ["./select-gl-code-v2.component.css"],
})
export class SelectGLCodeV2Component implements OnInit, OnDestroy {
  @Input() companyControl = new FormControl();
  @Output() selectionChange = new EventEmitter();
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;
  @Input() readPermissionDefintion;


  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  apiVisa: ApiVisa = AppConfig.apiVisa;

  allGlCodes:any
  searchGLCodes: any = [];
  statuses: any = ["ACTIVE", "INACTIVE"];
  form: FormGroup;

  constructor(    
    private fb: FormBuilder,
    private glcodeService: GlcodeService,

  ) {}

  ngOnInit(): void {
      this.subs.sink = this.glcodeService.get(this.apiVisa).subscribe((glCode: any) => {
        const glListing = glCode.data.map((data, index) => ({
          name: data.bl_fi_mst_glcode.gl_code_1,
          guid: data.bl_fi_mst_glcode.guid,
        }));
        this.allGlCodes = glListing;
        this.searchGLCodes = glListing
      });
  
      this.form = this.fb.group({
        // status: new FormControl(null),
        glCode: new FormControl(null),
        selectedGLCodeGuid: new FormControl(null),
      });
  }



  onSelectGLCode(glCode: any, event: any) {
    if (event.isUserInput) {
      console.log("gl code", glCode)
      this.viewModelStore.dispatch(this.ColumnViewActions.setAdvanceSearch_GLCodeField({ glCode: glCode }));
    }
  }


  applyGLCodeFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.searchGLCodes = this.allGlCodes.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  // onSelectStatus(status: any, event: any) {
  //   console.log("status", status)
  //     this.viewModelStore.dispatch(this.ColumnViewActions.setAdvanceSearch_Status({ status: status }));
    
  // }


  onReset() {
    this.form.controls["glCode"].patchValue( null );
    this.form.controls["selectedGLCodeGuid"].patchValue( null );
    this.viewModelStore.dispatch(this.ColumnViewActions.setAdvanceSearch_GLCodeField({ glCode: null }));
    // this.viewModelStore.dispatch(this.ColumnViewActions.setAdvanceSearch_Status({ status: null }));

  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
